import React, { Fragment } from "react";
import { Link } from "react-scroll";

const doctorDeptListMysore = [
  {
    id: 1,
    deptTitle: "Obstetrics & Gynaecology",
    dept: "obstetrics_and_gynecology",
  },
  {
    id: 17,
    dept: "paediatrics_and_neonatologist",
    deptTitle: "Pediatrics & Neonatologist",
  },
  {
    id: 2,
    dept: "paediatrics_and_subspeciatilies",
    deptTitle: "Paediatric Subspecialities",
  },
  {
    id: 3,
    deptTitle: "Developmental Paediatrics",
    dept: "developmental_pediatrics",
  },
  {
    id: 5,
    deptTitle: "Radiology & Fetal Medicine",
    dept: "fetal_medicine",
  },
  {
    id: 4,
    deptTitle: "Anaesthesia & Critical Care",
    dept: "anaesthesia_and_critical_care",
  },

  // {
  //   id: 6,
  //   deptTitle: "Endocrinology And Diabetology",
  //   dept: "endocrinology_and_diabetology",
  // },
  {
    id: 8,
    deptTitle: "Physicians",
    dept: "physicians",
  },
  {
    id: 18,
    deptTitle: "Paediatric Surgeon",
    dept: "pead_surgeon",
  },

  {
    id: 9,
    deptTitle: "Surgical Speciality",
    dept: "surgical_specialist",
  },

  {
    id: 15,
    deptTitle: "Other Specialities",
    dept: "other_specialities",
  },
];
const DeptList = ({ onSetActiveFunc }) => {
  const [deptList, setDeptList] = React.useState(doctorDeptListMysore);

  return (
    <Fragment>
      <br />
      <div className="container">
        <div className="row deptListDiv">
          {deptList.map((deptData) => (
            <div key={deptData.id} className="col-sm-4 cardComp">
              <Link
                activeclassname="active"
                to={deptData.dept}
                spy={true}
                smooth={true}
                duration={1000}
                delay={500}
                offset={-300}
                onSetActive={onSetActiveFunc}
              >
                <div className="card cardStyle">
                  <div className="card-body">
                    <h5 className="card-title cardTitle">
                      {deptData.deptTitle}
                    </h5>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
      <br />
    </Fragment>
  );
};

export default DeptList;
export { doctorDeptListMysore };
